var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.loading)?_c('div',{staticClass:"loadingBox"},[_c('a-spin',{staticClass:"loading"})],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }